<template>
    <div class="chat-container">
        <el-container>
            <el-header class="chat-header">
                <div class="header-content">
                    <div class="header-left">
                        <span class="online-count" v-if="onlineCount > 0">
                            {{ onlineCount }}人在线
                        </span>
                    </div>
                    <div class="header-title">
                        说点悄悄话吧
                    </div>
                    <div class="header-right">
                        <span class="connection-status" :class="connectionStatusClass">
                            {{ connectionStatusText }}
                        </span>
                        <el-dropdown trigger="click" @command="handleCommand">
                            <i class="el-icon-more"></i>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="logout">退出聊天</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </el-header>

            <el-main class="chat-main">
                <div class="message-list" ref="messageList">
                    <div v-for="(message, index) in messages" :key="index"
                        :class="['message-item', message.isSelf ? 'message-self' : 'message-other']">
                        <template v-if="!message.isSelf">
                            <div class="message-content">
                                <div class="message-info">
                                    <span class="message-username">{{ message.username || '对方' }}</span>
                                    <span class="message-time">{{ formatTime(message.time) }}</span>
                                </div>
                                <div class="message-bubble">
                                    <template v-if="message.type === 'text' || message.type === 'message'">
                                        {{ message.content }}
                                    </template>
                                    <template v-else-if="message.type === 'image'">
                                        <el-image :src="message.content" class="message-image"
                                            :preview-src-list="[message.content]" fit="contain">
                                        </el-image>
                                    </template>
                                    <template v-else-if="message.type === 'video'">
                                        <video :src="message.content" controls class="message-video"></video>
                                    </template>
                                    <template v-else-if="message.type === 'audio'">
                                        <audio :src="message.content" controls class="message-audio"></audio>
                                    </template>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="message-content">
                                <div class="message-info">
                                    <span class="message-time">{{ formatTime(message.time) }}</span>
                                    <span class="message-username">{{ '我' }}</span>
                                </div>
                                <div class="message-bubble">
                                    <template v-if="message.type === 'text' || message.type === 'message'">
                                        {{ message.content }}
                                    </template>
                                    <template v-else-if="message.type === 'image'">
                                        <el-image :src="message.content" class="message-image"
                                            :preview-src-list="[message.content]" fit="contain">
                                        </el-image>
                                    </template>
                                    <template v-else-if="message.type === 'video'">
                                        <video :src="message.content" controls class="message-video"></video>
                                    </template>
                                    <template v-else-if="message.type === 'audio'">
                                        <audio :src="message.content" controls class="message-audio"></audio>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </el-main>

            <el-footer class="chat-footer">
                <div class="input-area">
                    <div class="toolbar">
                        <el-upload action="/api/upload" :show-file-list="false" :before-upload="beforeUpload"
                            accept="image/*,video/*,audio/*">
                            <i class="el-icon-picture-outline"></i>
                        </el-upload>
                        <el-popover placement="top" width="300" trigger="click" v-model="showEmoji">
                            <div class="emoji-picker">
                                <div class="emoji-list">
                                    <span v-for="emoji in emojis" :key="emoji" class="emoji-item"
                                        @click="insertEmoji(emoji)">
                                        {{ emoji }}
                                    </span>
                                </div>
                            </div>
                            <img slot="reference" src="/表情.png" alt="emoji"
                                style="width: 22px; height: 22px; cursor: pointer; vertical-align: middle;" />
                        </el-popover>
                        <!-- <div class="voice-btn" 
                            @touchstart="startRecording" 
                            @touchend="stopRecording"
                            @touchcancel="cancelRecording">
                            <i class="el-icon-microphone"></i>
                        </div> -->
                        <span>播放提示音：
                            <el-switch v-model="isPlayAudio">
                            </el-switch>
                        </span>

                    </div>
                    <div class="input-box">
                        <el-input type="textarea" :rows="1" :autosize="{ minRows: 1, maxRows: 4 }" placeholder="请输入消息"
                            v-model="inputMessage" @keydown.enter.native="handleEnter"></el-input>
                        <el-button type="primary" class="send-btn" @click="sendMessage">发送</el-button>
                    </div>
                </div>
            </el-footer>
        </el-container>
        <audio ref="notificationSound" src="/notification.mp3" preload="auto"></audio>

        <!-- 录音动画弹窗 -->
        <el-dialog :visible.sync="showRecordingDialog" :show-close="false" :close-on-click-modal="false"
            :close-on-press-escape="false" width="300px" class="recording-dialog" center>
            <div class="recording-content">
                <div class="recording-icon" :class="{ 'recording': isRecording }">
                    <i class="el-icon-microphone"></i>
                </div>
                <div class="recording-waves" v-if="isRecording">
                    <div class="wave" v-for="n in 4" :key="n"></div>
                </div>
                <div class="recording-time">{{ formatRecordingTime }}</div>
                <div class="recording-tip">{{ recordingTip }}</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CryptoJS from 'crypto-js'

export default {
    name: 'Chat',
    data() {
        return {
            inputMessage: '',
            onlineCount: 0,
            showEmoji: false,
            isRecording: false,
            isPlayAudio: false,
            mediaRecorder: null,
            audioChunks: [],
            recordingTime: 0,
            recordingTimer: null,
            showRecordingDialog: false,
            recordingTip: '手指上滑，取消发送',
            hasRequestedPermission: false,
            aesKey: 'xiaoechat2025052',
            aesIv: 'xiaoechat2025052',
            emojis: [
                '😊', '😂', '🥰', '😍', '🤗', '😎', '🤔', '😴', '😭', '😡',
                '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥',
                '😶', '😐', '😑', '😬', '🙄', '😯', '😦', '😧', '😮', '😲',
                '😴', '🤤', '😪', '😵', '🤐', '🤢', '🤮', '🤧', '😷', '🤒',
                '🤕', '🤑', '🤠', '💩', '👻', '👽', '🤖', '😺', '😸', '😹',
                '😻', '😼', '😽', '🙀', '😿', '😾', '🙈', '🙉', '🙊', '💌',
                '💘', '💝', '💖', '💗', '💓', '💞', '💕', '💟', '❣️', '💔',
                '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '💯', '💢', '💥',
                '💫', '💦', '💨', '🕳️', '💣', '💬', '👁️‍🗨️', '🗨️', '🗯️', '💭',
                '💤', '👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️'
            ]
        }
    },
    computed: {
        ...mapState(['messages', 'isConnected', 'ws', 'clientId']),
        connectionStatusText() {
            if (this.isConnected) {
                return '已连接'
            } else if (this.ws && this.ws.readyState === WebSocket.CONNECTING) {
                return '重连中'
            } else {
                return '已断开'
            }
        },
        connectionStatusClass() {
            return {
                'status-connected': this.isConnected,
                'status-connecting': this.ws && this.ws.readyState === WebSocket.CONNECTING,
                'status-disconnected': !this.isConnected && (!this.ws || this.ws.readyState !== WebSocket.CONNECTING)
            }
        },
        formatRecordingTime() {
            const minutes = Math.floor(this.recordingTime / 60);
            const seconds = this.recordingTime % 60;
            return `${minutes}:${seconds.toString().padStart(2, '0')}`;
        }
    },
    watch: {
        messages: {
            handler() {
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        ...mapActions(['connectWebSocket', 'logout']),
        scrollToBottom() {
            const messageList = this.$refs.messageList;
            if (messageList) {
                setTimeout(() => {
                    messageList.scrollTop = messageList.scrollHeight;
                }, 100);
            }
        },
        formatTime(timestamp) {
            return new Date(timestamp).toLocaleTimeString()
        },
        handleLogout() {
            this.logout()
            this.$router.push('/')
        },
        playSound() {
            const audio = new Audio('/notification.mp3');
            audio.play().catch(err => {
                console.error('无法播放提示音:', err);
            });
        },
        encryptMessage(message) {
            const key = CryptoJS.enc.Utf8.parse(this.aesKey);
            const iv = CryptoJS.enc.Utf8.parse(this.aesIv);
            const encrypted = CryptoJS.AES.encrypt(message, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return encrypted.toString();
        },
        decryptMessage(encryptedMessage) {
            try {
                const key = CryptoJS.enc.Utf8.parse(this.aesKey);
                const iv = CryptoJS.enc.Utf8.parse(this.aesIv);
                const decrypted = CryptoJS.AES.decrypt(encryptedMessage, key, {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                });
                return decrypted.toString(CryptoJS.enc.Utf8);
            } catch (error) {
                console.error('解密消息失败:', error);
                return '';
            }
        },
        async sendMessage() {
            if (!this.inputMessage.trim()) return

            if (!this.$store.state.ws || this.$store.state.ws.readyState !== WebSocket.OPEN) {
                this.$message.error('聊天服务器未连接')
                return
            }

            const message = {
                type: 'message',
                content: this.inputMessage.trim(),
                time: Date.now(),
            }

            try {
                const encryptedMessage = this.encryptMessage(JSON.stringify(message));
                this.$store.state.ws.send(encryptedMessage);

                const selfMessage = { ...message, isSelf: true }
                this.$store.commit('ADD_MESSAGE', selfMessage)
                this.inputMessage = ''
                this.scrollToBottom()
            } catch (error) {
                this.$message.error('发送消息失败')
                console.error('Send message error:', error)
            }
        },
        beforeUpload(file) {
            const isImage = file.type.startsWith('image/')
            const isVideo = file.type.startsWith('video/')
            const isAudio = file.type.startsWith('audio/')

            if (!isImage && !isVideo && !isAudio) {
                this.$message.error('只能上传图片、视频或音频文件！')
                return false
            }

            const reader = new FileReader()
            reader.onload = (e) => {
                const message = {
                    type: isImage ? 'image' : isVideo ? 'video' : 'audio',
                    content: e.target.result,
                    time: Date.now(),
                    isSelf: true
                }
                const encryptedMessage = this.encryptMessage(JSON.stringify(message));
                this.$store.state.ws.send(encryptedMessage);
                this.$store.commit('ADD_MESSAGE', message)
            }
            reader.readAsDataURL(file)
            return false
        },
        showEmojiPicker() {
            this.showEmoji = true
        },
        insertEmoji(emoji) {
            this.inputMessage += emoji
            this.showEmoji = false
        },
        previewImage(url) {
            // 实现图片预览
        },
        handleEnter(e) {
            if (e.shiftKey) {
                return true
            } else {
                e.preventDefault()
                this.sendMessage()
            }
        },
        handleCommand(command) {
            if (command === 'logout') {
                this.$confirm('确定要退出聊天吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleLogout()
                }).catch(() => { })
            }
        },
        async requestMicrophonePermission() {
            if (this.hasRequestedPermission) return true;

            try {
                await this.$confirm('需要访问您的麦克风以发送语音消息，是否允许？', '权限请求', {
                    confirmButtonText: '允许',
                    cancelButtonText: '不允许',
                    type: 'info'
                });

                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                stream.getTracks().forEach(track => track.stop());
                this.hasRequestedPermission = true;
                return true;
            } catch (error) {
                this.$message.error('无法使用麦克风，请在浏览器设置中允许访问麦克风');
                return false;
            }
        },
        async startRecording(e) {
            e.preventDefault();

            // 检查权限
            if (!await this.requestMicrophonePermission()) {
                return;
            }

            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                this.mediaRecorder = new MediaRecorder(stream);
                this.audioChunks = [];
                this.isRecording = true;
                this.recordingTime = 0;
                this.showRecordingDialog = true;
                this.recordingTip = '手指上滑，取消发送';

                this.mediaRecorder.ondataavailable = (event) => {
                    this.audioChunks.push(event.data);
                };

                this.mediaRecorder.start();
                this.recordingTimer = setInterval(() => {
                    this.recordingTime++;
                    if (this.recordingTime >= 60) { // 最长录音60秒
                        this.stopRecording();
                    }
                }, 1000);

            } catch (error) {
                console.error('录音失败:', error);
                this.$message.error('无法访问麦克风');
            }
        },
        async stopRecording(e) {
            if (!this.isRecording) return;

            // 检查是否取消发送
            if (e && e.changedTouches && e.changedTouches[0]) {
                const touch = e.changedTouches[0];
                const startY = this.touchStartY;
                const endY = touch.clientY;

                if (startY - endY > 50) { // 上滑超过50px
                    this.cancelRecording();
                    return;
                }
            }

            clearInterval(this.recordingTimer);
            this.isRecording = false;
            this.showRecordingDialog = false;

            if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
                this.mediaRecorder.stop();
                this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
            }

            // 如果录音时间太短，取消发送
            if (this.recordingTime < 1) {
                this.$message.warning('录音时间太短');
                return;
            }

            // 询问是否发送
            try {
                await this.$confirm(`是否发送语音消息？(${this.formatRecordingTime})`, '提示', {
                    confirmButtonText: '发送',
                    cancelButtonText: '取消',
                    type: 'info'
                });

                // 将录音数据转换为 Blob
                const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
                const audioUrl = URL.createObjectURL(audioBlob);

                // 发送语音消息
                const message = {
                    type: 'audio',
                    content: audioUrl,
                    time: Date.now(),
                    isSelf: true,
                    duration: this.recordingTime
                };

                this.$store.commit('ADD_MESSAGE', message);
                this.$store.state.ws.send(JSON.stringify(message));
                this.scrollToBottom();

            } catch (error) {
                // 用户取消发送
                console.log('取消发送语音消息');
            }
        },
        cancelRecording() {
            if (this.isRecording) {
                clearInterval(this.recordingTimer);
                this.isRecording = false;
                this.showRecordingDialog = false;
                if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
                    this.mediaRecorder.stop();
                    this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
                }
                this.$message.info('已取消录音');
            }
        },
        touchStart(e) {
            this.touchStartY = e.touches[0].clientY;
        }
    },
    async mounted() {
        try {
            const ws = await this.$store.dispatch('connectWebSocket')
            ws.onmessage = (event) => {
                const message = JSON.parse(event.data)
                if (message.type === 'clientId') {
                    this.$store.commit('SET_CLIENT_ID', message.clientId)
                } else if (message.type === 'onlineCount') {
                    this.onlineCount = message.count
                } else {
                    const isSelfMessage = message.sender_id === this.$store.state.clientId
                    if (!isSelfMessage) {
                        const decryptedContent = this.decryptMessage(message.content);
                        const decryptedMessage = JSON.parse(decryptedContent);
                        decryptedMessage.isSelf = false;
                        if (decryptedMessage.username) {
                            this.$store.commit('ADD_MESSAGE', decryptedMessage)
                            if (this.isPlayAudio){
                                this.playSound()
                            }
                            
                        }
                    }
                }
            }
        } catch (error) {
            console.error('WebSocket connection error:', error)
            this.$message.error('连接聊天服务器失败: ' + (error.message || '未知错误'))
            // 如果是因为未登录，返回登录页
            if (error.message && error.message.includes('未登录')) {
                this.$router.push('/')
            }
        }
    },
    beforeDestroy() {
        if (this.$store.state.ws) {
            this.$store.state.ws.close()
        }
    }
}
</script>

<style scoped>
.chat-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
}

.chat-header {
    background-color: #409EFF;
    color: white;
    padding: 0;
    height: 50px !important;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}

.header-content {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}

.header-left {
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
}

.online-count {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    background-color: rgba(255, 255, 255, 0.2);
    padding: 2px 8px;
    border-radius: 12px;
}

.header-title {
    font-size: 16px;
    font-weight: 500;
}

.header-right {
    font-size: 20px;
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.connection-status {
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 10px;
    color: white;
}

.status-connected {
    background-color: #67C23A;
}

.status-connecting {
    background-color: #E6A23C;
}

.status-disconnected {
    background-color: #F56C6C;
}

.header-right i {
    color: white;
}

.el-dropdown-menu {
    min-width: 100px;
}

.el-dropdown-menu__item {
    font-size: 14px;
    padding: 8px 20px;
}

.chat-main {
    padding: 0;
    margin-top: 50px;
    margin-bottom: 60px;
    flex-grow: 1;
    position: relative;
}

.message-list {
    height: 90%;
    overflow-y: auto;
    padding: 15px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 50;
    -webkit-overflow-scrolling: touch;
}

.message-list {
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
}

.message-item {
    display: flex;
    align-items: flex-end;
    margin-bottom: 20px;
    padding: 0 15px;
}

.message-self {
    flex-direction: row-reverse;
}

.message-other {
    flex-direction: row;
}

.message-content {
    max-width: 70%;
    display: flex;
    flex-direction: column;
}

.message-self .message-content {
    align-items: flex-end;
}

.message-other .message-content {
    align-items: flex-start;
}

.message-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
    padding: 0 4px;
}

.message-self .message-info {
    flex-direction: row-reverse;
}

.message-username {
    font-size: 12px;
    color: #606266;
    font-weight: 500;
    margin: 0 4px;
}

.message-time {
    font-size: 12px;
    color: #999;
}

.message-bubble {
    padding: 10px 16px;
    border-radius: 18px;
    background-color: #fff;
    word-break: break-word;
    position: relative;
    display: inline-block;
    line-height: 1.7;
    font-size: 16px;
    /*border: 1px solid #e5e5e5;*/
    box-shadow: none;
    color: #222;
    max-width: 100%;
}

.message-self .message-bubble {
    background-color: #95ec69;
    color: #222;
    border: none;
    border-radius: 6px;
    /* 左上 18, 右上 6, 右下 6, 左下 18 */
    margin-left: 40px;
    position: relative;
}

.message-other .message-bubble {
    background-color: #fff;
    color: #222;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    margin-right: 40px;
}

.message-self .message-bubble::after {
    content: '';
    position: absolute;
    top: 16px;
    /* 让三角形稍微下移，和气泡正好贴合 */
    right: -7px;
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid #95ec69;
}

.message-other .message-bubble::after {
    content: '';
    position: absolute;
    top: 16px;
    left: -7px;
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid #fff;
    border-left: none;

}

.message-image {
    max-width: 200px;
    max-height: 300px;
    min-width: 100px;
    min-height: 100px;
    border-radius: 12px;
    cursor: pointer;
    transition: transform 0.2s;
    display: block;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.message-image:hover {
    transform: scale(1.02);
}

.message-video {
    max-width: 250px;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.message-audio {
    min-width: 120px;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chat-footer {
    background-color: #f5f5f5;
    padding: 0;
    height: auto !important;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    border-top: 1px solid #e6e6e6;
}

.input-area {
    padding: 10px;
    background-color: #f5f5f5;
}

.toolbar {
    display: flex;
    gap: 15px;
    margin-bottom: 10px;
    padding: 0 5px;
}

.toolbar i {
    font-size: 24px;
    color: #666;
    cursor: pointer;
}

.input-box {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    background-color: white;
    border-radius: 4px;
    padding: 5px;
}

.input-box .el-textarea {
    margin-bottom: 0;
}

.input-box .el-textarea__inner {
    border: none;
    resize: none;
    padding: 8px;
    max-height: 100px;
    background-color: transparent;
}

.send-btn {
    padding: 8px 15px;
    height: auto;
    border-radius: 4px;
}

.emoji-picker {
    padding: 10px;
}

.emoji-list {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 8px;
    max-height: 200px;
    overflow-y: auto;
}

.emoji-item {
    font-size: 20px;
    cursor: pointer;
    text-align: center;
    padding: 5px;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.emoji-item:hover {
    background-color: #f0f0f0;
}

.emoji-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #666;
    padding: 4px;
}

.emoji-icon:hover {
    color: #409EFF;
}

.emoji-icon svg {
    width: 24px;
    height: 24px;
}

.voice-btn {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #666;
    transition: color 0.3s;
}

.voice-btn:hover {
    color: #409EFF;
}

.voice-btn i {
    font-size: 20px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .message-content {
        max-width: 85%;
    }

    .message-bubble {
        font-size: 15px;
        padding: 8px 12px;
    }

    .message-self .message-bubble {
        margin-left: 20px;
    }

    .message-other .message-bubble {
        margin-right: 20px;
    }

    .message-self .message-bubble::after,
    .message-other .message-bubble::after {
        top: 12px;
    }

    .message-image {
        max-width: 150px;
        max-height: 200px;
        min-width: 80px;
        min-height: 80px;
    }

    .message-video {
        max-width: 200px;
    }

}

.toolbar i:hover {
    color: #409EFF;
}

.recording-dialog {
    background: rgba(0, 0, 0, 0.7);
}

.recording-dialog .el-dialog {
    background: transparent;
    box-shadow: none;
}

.recording-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
}

.recording-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #409EFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
}

.recording-icon i {
    font-size: 30px;
    color: white;
}

.recording-icon.recording {
    animation: pulse 1.5s infinite;
}

.recording-waves {
    display: flex;
    align-items: center;
    gap: 3px;
    margin-bottom: 10px;
}

.wave {
    width: 3px;
    height: 15px;
    background: #409EFF;
    border-radius: 3px;
    animation: wave 1s infinite;
}

.wave:nth-child(2) {
    animation-delay: 0.2s;
}

.wave:nth-child(3) {
    animation-delay: 0.4s;
}

.wave:nth-child(4) {
    animation-delay: 0.6s;
}

.recording-time {
    color: white;
    font-size: 16px;
    margin-bottom: 10px;
}

.recording-tip {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes wave {
    0% {
        height: 15px;
    }

    50% {
        height: 25px;
    }

    100% {
        height: 15px;
    }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .recording-icon {
        width: 50px;
        height: 50px;
    }

    .recording-icon i {
        font-size: 25px;
    }

    .recording-time {
        font-size: 14px;
    }

    .recording-tip {
        font-size: 12px;
    }
}

/* 电脑端适配：限制最大宽度并居中 */
@media screen and (min-width: 769px) {
    .chat-container {
        max-width: 550px;
        margin: 0 auto;
        /* Header 和 Footer 也需要相应调整，使其在限制宽度内 */
    }

    .chat-header,
    .chat-footer {
        max-width: 550px;
        margin: 0 auto;
        left: 0;
        /* Reset fixed position left/right */
        right: 0;
    }

    /* 调整 main 内容区域以适应新的固定 header/footer */
    .chat-main {
        margin-top: 50px;
        /* Match header height */
        margin-bottom: 60px;
        /* Match footer height */
        padding: 0;
        /*position: relative;*/
        /* 已有，确认 */
    }

    .message-list {
        /*position: absolute;*/
        /* 已有，确认 */
        top: 0;
        /* 已有，确认 */
        left: 0;
        /* 已有，确认 */
        right: 0;
        /* 已有，确认 */
        bottom: 0;
        /* 让 message-list 填充 chat-main */
        height: auto;
        /* Let content determine height */
    }
}
</style>